// extracted by mini-css-extract-plugin
module.exports = {"form":"contactform--form---sXsw","open":"contactform--open--3L9Pc","close":"contactform--close--FrQQv"};